import find from 'lodash/find'
import isEqual from 'lodash/isEqual'
import findDeep from 'lib/findDeep'
import createTypes from 'constants/createTypes'
import authTypes from 'constants/authTypes'

type ApiAction = import('types/api').ApiAction
type RootState = import('types/state').RootState

type MiddlewareStore = {
  getState: () => RootState & {
    localIds?: Record<string, unknown>
    pendingActions?: {
      actions?: unknown[]
    }
  }
}

type NextFn = (action: ApiAction) => unknown


const createTypeArrays = createTypes.map((a: { REQUEST: string; RECEIVE: string; FAIL: string }) => [a.REQUEST, a.RECEIVE, a.FAIL])
const authTypeArrays = authTypes.map((a: { REQUEST: string; RECEIVE: string; FAIL: string }) => [a.REQUEST, a.RECEIVE, a.FAIL])

const preRequest = (store: MiddlewareStore) => (next: NextFn) => (action: ApiAction) => {
  if (!(action.types && action.meta?.request)) {
    return next(action)
  }
  if (find(authTypeArrays, (t: string[]) => isEqual(t, action.types))) {
    return next(action)
  }
  if (!action.meta?.retry) {
    return next(action)
  }
  action.meta.retries ??= 0
  const state = store.getState()
  const isCreate = find(createTypeArrays, (t: string[]) => isEqual(t, action.types))
  const hasLocal = findDeep(action.payload, (val: unknown, key: string | number) => {
    if (isCreate && key === 'id') {
      return false
    }
    return state.localIds?.[String(val)] != null
  })
  const anyPending = (state.pendingActions?.actions?.length || 0) > 0
  if (hasLocal || (anyPending && !action.meta?.isRetry)) {
    action.meta.tempRequest = action.meta.request
    delete action.meta.request
    action.type = action.types[0]
    action.meta ??= {}
    action.meta.pending = true
  }
  return next(action)
}

const postRequest = (_store: MiddlewareStore) => (next: NextFn) => (action: ApiAction) => {
  if (action.meta?.tempRequest) {
    action.meta.request = action.meta.tempRequest
    delete action.meta.tempRequest
  }
  return next(action)
}

export { preRequest }
export { postRequest }